
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import {grey} from "@mui/material/colors";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: grey[50], // Improved color
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default StyledTableRow;